import { Card, CardContent, styled } from '@mui/material';
import { theme } from 'v3/styles/global-styles';

export const CardStyled = styled(Card)(() => ({
  width: '100%',
  color: 'white',
  background: theme.palette.primary.main,
  border: `1px solid ${theme.palette.secondary.dark}`,
}));

export const CardContentStyled = styled(CardContent)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  paddingleft: '1.5rem',
  width: '100%',

  [theme.breakpoints.up('sm')]: {
    alignItems: 'start',
  },
}));

export const AlignMiniButton = styled('div')(() => ({
  [theme.breakpoints.up('sm')]: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '3rem',
    gap: '5rem',
  },
  [theme.breakpoints.up('lg')]: {
    paddingLeft: '5rem',
  },
}));
